import React from 'react';
import { useSelector } from 'react-redux';

import { Select, Input, InputNumber } from 'antd';

import FileUpload from '../../../../../../components/FileUpload';
import { getAsNumber } from '../../../../../../utilities/numberConvertion';

const getOptions = (list) => {
  return list.map((item) => ({
    value: item.value,
    label: <div>{item.label}</div>,
    credit: item.credit
  }));
};

export const TableCol = (action, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { course_type: courseType } = staticData;


  const getCourseForRow = (row) => {
    if (!courseType?.length || row?.name === undefined || row?.name === null) return {};
    const match = courseType.filter((item) => item.value === Number(row.name));

    return match.length ? match[0] : {};
  };

  return [
    {
      key: 'name',
      dataIndex: 'name',
      title: 'Course',
      render: (value, row) => {

        const _courseType = courseType?.length > 0 ? courseType.filter((item) => item.value === Number(value)) : [];
        const _course = _courseType.length ? _courseType[0] : {};


        const { value: courseValue } = _course;

        return courseType?.length ? (
          <Select
            style={{ width: '140px' }}
            options={getOptions(courseType)}
            value={courseValue}
            defaultValue={courseValue}
            placeholder="Select a Course"
            disabled={status === 1 || status === 2 || status === 3}
            // onChange={(e, selected) => {
            //   const isWaiver =
            //     selected?.label?.props?.children?.toLowerCase?.() === 'course waiver';

            //   action({
            //     ...row,
            //     name: e,
            //     credit: selected.credit,
            //     score: isWaiver ? 3 : row.score,
            //   });
            // }}
            onChange={(e, selected) => {
              const isWaiver =
                selected?.label?.props?.children?.toLowerCase?.() === 'course waiver';

              const wasWaiver = getCourseForRow(row)?.label?.toLowerCase?.() === 'course waiver';

              let newScore = row.score;
              if (isWaiver) {
                newScore = 3;
              } else if (wasWaiver) {
                // was forced to 3 by waiver, now switching away — clear it
                newScore = null;
              }
              // else: not waiver before or after — leave row.score untouched

              action({
                ...row,
                name: e,
                credit: selected.credit,
                score: newScore,
              });
            }}
          />
        ) : (
          <></>
        );
      }
    },
    {
      key: 'credit',
      dataIndex: 'credit',
      title: 'Credits',

    },

    {
      key: 'course_name',
      dataIndex: 'course_name',
      title: 'Course Name',
      render: (value, row) => {
        const isWaiver = getCourseForRow(row)?.label?.toLowerCase?.() === 'course waiver';
        return (
          <Input
            placeholder="Enter"
            value={value}
            onChange={(e) => action({ ...row, course_name: e.target.value })}
            disabled={status === 1 || status === 2 || status === 3 || isWaiver}
          />
        )
      }
    },
    {
      key: 'course_code',
      dataIndex: 'course_code',
      title: 'Course Code',
      render: (value, row) => {
        const isWaiver = getCourseForRow(row)?.label?.toLowerCase?.() === 'course waiver';
        return (
          <Input
            placeholder="Enter"
            value={value}
            onChange={(e) => action({ ...row, course_code: e.target.value })}
            disabled={status === 1 || status === 2 || status === 3 || isWaiver}
          />
        )
      }
    },
    {
      key: 'section',
      dataIndex: 'section',
      title: 'Section',
      render: (value, row) => {
        const isWaiver = getCourseForRow(row)?.label?.toLowerCase?.() === 'course waiver';
        return (
          <Input
            placeholder="Enter"
            value={value}
            onChange={(e) => action({ ...row, section: getAsNumber(e.target.value) })}
            disabled={status === 1 || status === 2 || status === 3 || isWaiver}
          />
        )
      }
    },
    // {
    //   key: 'score',
    //   dataIndex: 'score',
    //   title: 'Score From IRAS',
    //   render: (value, row) => {
    //     return (
    //       <InputNumber
    //         placeholder={"Enter"}
    //         value={value}
    //         onChange={(e) => action({ ...row, score: e })}
    //         min={0}
    //         max={5}
    //         disabled={status === 1 || status === 2 || status === 3 || true }
    //       />
    //     )
    //   }
    // },
    {
      key: 'score',
      dataIndex: 'score',
      title: 'Score From IRAS',
      render: (value, row) => {
        const isWaiver = getCourseForRow(row)?.label?.toLowerCase?.() === 'course waiver';

        if (isWaiver) {
          return <span>{value ?? '-'}</span>;
        }

        return (
          <InputNumber
            placeholder="Enter"
            value={value ?? 0}
            onChange={(e) => action({ ...row, score: e })}
            min={0}
            max={5}
            disabled={status === 1 || status === 2 || status === 3}
          />
        );
      }
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments',
      render: (fileList, row) => (
        <FileUpload
          fileList={fileList}
          row={row}
          action={action}
          status={status}
          disabled={status === 1 || status === 2 || status === 3} />
      )
    }
  ];
};
